import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgRightCi({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm-1.707 3.293a1 1 0 011.32-.083l.094.083 4 4 .083.094a1 1 0 010 1.226l-.083.094-4 4-.094.083a1 1 0 01-1.226 0l-.094-.083-.083-.094a1 1 0 010-1.226l.083-.094L13.585 12l-3.292-3.293-.083-.094a1 1 0 01.083-1.32z"
        fill={color}
      />
    </svg>
  )
}

export default SvgRightCi
